// src/App.tsx
import React, { useEffect, useState } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import TopBar from "./components/TopBar";
import Accueil from "./pages/Accueil";
import NosProjets from "./pages/NosProjets";
import Produits from "./pages/Produits";
import ServiceApresVente from "./pages/ServiceApresVente";
import CleanPressing from "./pages/CleanPressing";
import QuiSommesNous from "./pages/QuiSommesNous";
import ProductDetails from "./pages/ProductDetails";
import Contact from "./pages/Contact";
import LavageProfessionnel from "./pages/LavageProfessionnel";
import logo from "./assets/images/logo entreprise.png";
import ScrollToTop from "./components/ScrollToTop";

const AppContent: React.FC = () => {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith("/espace-client/admin");

  const [loading, setLoading] = useState(true);

useEffect(() => {
  const timer = setTimeout(() => {
    setLoading(false);
  }, 2000);

  return () => clearTimeout(timer);
}, []);

  // ✅ AJOUT ICI (écran de chargement)
  if (loading) {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white">
      <img
        src={logo}
        className="h-20 w-auto animate-pulse scale-100 animate-[fadeInZoom_1.2s_ease-in-out]"
        alt="loading"
      />
    </div>
  );
}

  return (
    <>
     <TopBar />
      {!isAdminPage && <Navbar />}
      <Routes>
        <Route path="/" element={<Accueil />} />
        <Route path="/qui-sommes-nous" element={<QuiSommesNous />} />
        <Route path="/nos-projets" element={<NosProjets />} />
        <Route path="/produits" element={<Produits />} />
        <Route path="/service-apres-vente" element={<ServiceApresVente />} />
        <Route path="/product-details/:id" element={<ProductDetails />} />
        <Route path="/clean-pressing" element={<CleanPressing />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/lavage-professionnel" element={<LavageProfessionnel />} />

      </Routes>
      {!isAdminPage && <Footer />}
    </>
  );
};

const App: React.FC = () => (
  <BrowserRouter>
  <ScrollToTop />
    <AppContent />
  </BrowserRouter>
);

export default App;